export default function stringify(value) {
  if ([null, undefined, ''].indexOf(value) > -1) {
    return '';
  }

  return String(value);
}
